import {useRef} from 'react'
import {v4 as uuidv4} from 'uuid'

export const useId = (override?: string) => {
  const idRef = useRef(uuidv4())

  return override || idRef.current
}
